import React, { useState } from "react";
import { IoMdMail } from "react-icons/io";
import { IoLocation } from "react-icons/io5";
import { BiSolidPhoneCall } from "react-icons/bi";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";
import logo from "../../Assets/Logos/FooterLogo.svg";
import { useNavigate } from "react-router-dom";

// Icon box component
const IconBox = ({ children }) => (
  <div
    className="flex-shrink-0 flex items-center justify-center rounded-2xl bg-[#89ea5f]"
    style={{
      width: "64px",
      height: "64px",
    }}
  >
    {children}
  </div>
);

// Green bullet dot
const Dot = () => (
  <span
    className="flex-shrink-0 w-2 h-2 rounded-full mt-1.5"
    style={{ background: "#4ade80" }}
  />
);

const UserFooter = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Notices", path: "/career" },
    { label: "Contact Us", path: "/contact" },
    { label: "Admin Login", path: "/login" },
  ];

  const services = [
    "Hybrid Energy",
    "Renewable Energy",
    "Solar Maintenance",
    "Solar PV Systems",
    "Solar Solutions",
  ];

   const usefulLinks = [
    { label: "Privacy Policy", path: "/privacy-policy" },
    { label: "Term & Conditions", path: "/termcondition" },
    { label: "Warranty", path: "/" },
    { label: "Support", path: "/support" },
  ];

  return (
    <footer
      className="w-full bg-[#163300] font-josefin relative overflow-hidden"
    >
      {/* Subtle texture overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle, rgba(74,222,128,0.04) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />

      {/* ── Top contact bar ── */}
      <div
        className="relative z-10 border-b"
        style={{ borderColor: "rgba(74,222,128,0.15)" }}
      >
        <div className=" mx-auto px-6 md:px-10 lg:px-12 xl:px-20 py-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">

            {/* Support & Email */}
            <div className="flex items-center gap-4">
              <IconBox>
                <IoMdMail className="text-white text-2xl" />
              </IconBox>
              <div>
                <p className="text-white font-bold text-base md:text-lg">Support & Email</p>
                <a
                  href="mailto:info@agservicess.com"
                  className="text-gray-300 text-sm md:text-base hover:text-green-400 transition-colors"
                >
                  info@viswarajaent.com
                </a>
              </div>
            </div>

            {/* Customer Support */}
            <div className="flex items-center gap-4">
              <IconBox>
                <BiSolidPhoneCall className="text-white text-2xl" />
              </IconBox>
              <div>
                <p className="text-white font-bold text-base md:text-lg">Customer Support</p>
                <a
                  href="tel:+918144915882"
                  className="text-gray-300 text-sm md:text-base hover:text-green-400 transition-colors"
                >
                  +91 82496 75658
                </a>
              </div>
            </div>

            {/* Our Location */}
            <div className="flex items-center gap-4">
              <IconBox>
                <IoLocation className="text-white text-2xl" />
              </IconBox>
              <div>
                <p className="text-white font-bold text-base md:text-lg">Our Location</p>
                <p className="text-gray-200 text-sm md:text-base leading-snug">
                 Head Office Address -432/2295,
Backside of Odean Talkies, Po- Sahadevkhunta, Baleshwar, 756001
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Main footer columns ── */}
      <div className="relative z-10 px-6 md:px-10 lg:px-12 xl:px-20 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Col 1 — Brand */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <img src={logo} alt="Logo" className="h-16 w-auto object-cover " />
            </div>

            <p className="text-gray-400 text-sm leading-relaxed">
               At Vishwaraja Enterprises, our goal is not just to meet expectations but to exceed them through consistency, quality, and commitment.
            </p>

            {/* Social icons */}
            <div className="flex items-center gap-3">
              {[
                { Icon: FaFacebookF, href: "#" },
                { Icon: FaLinkedinIn, href: "#" },
                { Icon: FaXTwitter, href: "#" },
                { Icon: FaInstagram, href: "#" },
              ].map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  className="flex items-center justify-center rounded-lg transition-all duration-200 hover:scale-110"
                  style={{
                    width: "36px",
                    height: "36px",
                    background: "rgba(74,222,128,0.12)",
                    border: "1px solid rgba(74,222,128,0.25)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "linear-gradient(135deg, #6ee85a 0%, #3dcc40 100%)";
                    e.currentTarget.style.border = "1px solid transparent";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(74,222,128,0.12)";
                    e.currentTarget.style.border = "1px solid rgba(74,222,128,0.25)";
                  }}
                >
                  <Icon className="text-green-400 text-sm" style={{ color: "inherit" }} />
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Quick Links */}
          <div>
            <h4 className="text-white font-black text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map(({ label, path }) => (
                <li key={label} className="flex items-start gap-2">
                  <Dot />
                  <button
                    onClick={() => handleNavigation(path)}
                    className="text-gray-400 text-sm hover:text-green-400 transition-colors text-left"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Services */}
          <div>
            <h4 className="text-white font-black text-lg mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s} className="flex items-start gap-2">
                  <Dot />
                  <span className="text-gray-400 text-sm hover:text-green-400 transition-colors cursor-pointer">
                    {s}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4 — Useful Links */}
          <div>
            <h4 className="text-white font-black text-lg mb-6">Useful Links</h4>
            <ul className="space-y-3">
              {usefulLinks.map((l) => (
                <li key={l} 
                onClick={()=>{
                  navigate(`${l.path}`);
                  window.scrollTo(0,0);
                }}
                className="flex items-start gap-2">
                  <Dot />
                  <span className="text-gray-400 text-sm hover:text-green-400 transition-colors cursor-pointer">
                    {l.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      {/* ── Green copyright bar ── */}
      <div className="relative z-10 px-8 pb-8">
        <div
          className="max-w-6xl mx-auto flex items-center justify-center py-4 rounded-2xl"
          style={{
            background: "linear-gradient(135deg, #6ee85a 0%, #3dcc40 100%)",
            boxShadow: "0 4px 20px rgba(74,222,128,0.3)",
          }}
        >
          <p className="text-[#0d2d0d] font-semibold text-sm text-center">
            Copyright © {currentYear} Solor. All rights reserved.{" "}
            <button
              onClick={() => window.open("https://webbocket.com/", "_blank")}
              className="underline hover:opacity-80 transition-opacity ml-1"
            >
              Design by Web_Bocket
            </button>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default UserFooter;